import { addNavbarNotification, getCurrentUserId, loadNavbarNotifications } from "./navbarNotifications";

const ACK_STORAGE_KEY = "hrmsOnboardingNotifyAck";

function readAckMap() {
  try {
    const raw = localStorage.getItem(ACK_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeAckMap(map) {
  try {
    localStorage.setItem(ACK_STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* ignore */
  }
}

function ackKey(requestId) {
  const userId = getCurrentUserId();
  return `${userId || "anon"}:${requestId}`;
}

/** Whether the current user already acknowledged a notify-only onboarding item. */
export function isOnboardingNotifyAcknowledged(requestId) {
  if (!requestId) return false;
  return !!readAckMap()[ackKey(requestId)];
}

/** Mark a notify-only desk item as acknowledged (No action required). */
export function acknowledgeOnboardingNotify(requestId) {
  if (!requestId) return;
  const map = readAckMap();
  map[ackKey(requestId)] = Date.now();
  writeAckMap(map);
}

/**
 * When the assignee loads Approvals desk, seed navbar bell for:
 * - notify-only FYI items
 * - real onboarding approval-required items
 * (Submitter's browser cannot push into another user's localStorage.)
 */
export function syncNotifyOnlyNavbarFromDesk(deskRows = []) {
  const userId = getCurrentUserId();
  if (!userId) return;

  const pendingRows = (Array.isArray(deskRows) ? deskRows : []).filter(
    (row) => row?.status === "Pending"
  );
  if (!pendingRows.length) return;

  const existing = loadNavbarNotifications();
  let added = 0;

  pendingRows.forEach((row) => {
    const isNotify = !!row?.notifyOnlyFyi;
    const sourceId = isNotify
      ? `onboarding_notify_${row.onboardingRequestId}`
      : `onboarding_approval_${row.onboardingRequestId}`;
    if (existing.some((n) => n.sourceId === sourceId && String(n.userId) === String(userId))) {
      return;
    }
    if (isNotify && isOnboardingNotifyAcknowledged(row.requestId)) return;

    const name = row.userName || "New employee";
    const code = row.employeeCode || row.employeeId || row.formData?.candidateId || "candidate";
    addNavbarNotification({
      userId,
      title: isNotify
        ? "New team member onboarded (FYI)"
        : "Onboarding approval required",
      message: isNotify
        ? `${name} (${code}) has joined. No approval action is required from you.`
        : `${name} (${code}) is pending your approval.`,
      type: isNotify ? "onboarding_notify" : "onboarding",
      sourceId,
    });
    added += 1;
  });

  return added;
}
